<template>
  <div class="news">
    <div class="newsXq">
        <p class="title">{{htmlText.title}}</p>
        <p class="desc">{{htmlText.englishTitle}}</p>
        <div class="contentHtml" v-html="htmlText.text"></div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api'
export default {
  name: 'departmentXq',
  data () {
    return {
      htmlText:""
      }
  },
  created(){
      api.getXq({
          id:this.$route.params.id
      }).then(res=>{
          if(res.data.code===0){
              this.htmlText = res.data.data.newsDetail;
          }
      })
  }
}
</script>
<style lang="scss" scoped>
  .news{
    width: 100%;
    .newsXq{
        width: 1200px;
        margin: 0 auto;
        .title{
            width: 100%;
            line-height: 34px;
            font-size: 28px;
            font-weight: bold;
            margin-top: 30px;
        }
        .desc{
            font-size: 16px;
            line-height: 24px;
            color: #909399;
            margin-top: 12px;
            padding-bottom: 22px;
        }
    }
  }
  @media screen and (max-width: 1200px){
    .news{
      .newsXq{
        width: 100%;
        box-sizing: border-box;
        padding: 0 24px;
        .title{
          font-size: 24px;
        }
        .desc{
          font-size: 14px;
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/department/departmentXq.vue